import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { GET_ONE, Button, GET_LIST } from "react-admin";
import dataProviderFactory from "../dataProvider";
import IconCancel from "@material-ui/icons/Cancel";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Book from "@material-ui/icons/Book";
import { isNil, filter, propEq, prop, head, map, isEmpty, pathOr, propOr } from "ramda";
import styled from "styled-components";
import LinearProgress from "@material-ui/core/LinearProgress";
import moment_tz from 'moment-timezone';
import {  UPDATE } from 'react-admin'
import { getCountryByID, getNationality } from "../util/getCountryById";

const shirtSize = { 1: "S (EU) | XS (US)", 2: "M (EU) | S (US)", 3: "L (EU) | M (US)", 4: "XL (EU) | L (US)", 5: "XXL (EU) | XL (US)", 6: "XXXL (EU) | XXL (US)" };

const StyledH4 = styled.h4({
  color: "#ff9800",
});

class TourBookingFormButton extends Component {
  async fetchData(id) {
    const dataProvider = await dataProviderFactory("rest");
    const response = await dataProvider(GET_ONE, "bookings", { id });
    const priceDate = prop('price_date', response.data);

    const responsePrices = await dataProvider(GET_LIST, "prices", {
      filter: {
        for_date: priceDate,
        for_tour_id: response.data.tour_id,
      },
      pagination: {
        page: 1,
        perPage: 99999,
      },
      sort: {}
    });

    const gpsPrices = await dataProvider(GET_LIST, "prices", {
      filter: {
        price_item_type: "gps_device",
        for_date: priceDate,
      },

      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: "start_date", order: "DESC" }
    });

    const insurancePrices = await dataProvider(GET_LIST, "prices", {
      filter: {
        price_item_type: "insurance",
        for_date: priceDate,
      },

      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: "start_date", order: "DESC" }
    });

    const responseClient = await dataProvider(GET_ONE, "clients", {
      id: response.data.client_id,
    });
    return Object.assign(
      {
        tour_prices: responsePrices.data,
        pastRentals: responseClient.data.rentals,
        referral: responseClient.data.referral,
        gpsPrices: gpsPrices.data,
        insurancePrices: insurancePrices.data,
      },
      response.data
    );
  }

  state = {
    data: null,
    error: false,
    editBooking: false,
    r_last_name:null,
    r_first_name: null,
    showDialog: false,
    retirementDate: Date.now(),
    countries: [],
  };

  async componentDidUpdate() {
    if (this.state.showDialog && isNil(this.state.data)) {
      const id = this.props.bookingId;
      await this.updateState(id);
    }
  }

  async componentDidMount() {
    moment_tz.tz.setDefault("Europe/Madrid");
    await this.loadCountries();
  }

  loadCountries = async () => {
    try {
      const dataProvider = await dataProviderFactory("rest");
      const response = await dataProvider(GET_LIST, "countries", {
        pagination: {
          page: 1,
          perPage: 1000,
        },
        filter: {},
        sort: { field: "country", order: "ASC" },
      });
      this.setState({ countries: response.data });
    } catch (error) {
      console.error("Error loading countries:", error);
    }
  };

  updateState = async (id) => {
    const data = await this.fetchData(id);
    this.setState({ data });
  };

  handleClick = () => {
    this.setState({ showDialog: true });
  };

  handleCloseClick = () => {
    this.setState({ showDialog: false });
  };

  renderTourDates(tour) {
    const startDate = moment(tour.tour_start_date);
    const endDate = moment(tour.tour_end_date);
    const startDatePart = startDate.format('MMMM D');
    const endDatePart = startDate.isSame(endDate, 'month')
      ? endDate.format('D, YYYY')
      : endDate.format('MMMM D, YYYY');

    return `${startDatePart} - ${endDatePart}`;
  };
  
  habilitarTextboxBooking = () => {
    console.log('edit')
    console.log(this.state.editBooking )
    this.setState({ editBooking: !this.state.editBooking });
  }

  handleChange = (element, type) => {
    this.setState({
      [type]: element.target.value,
    });
  }
  handleSubmitEditBooking = (event) => {
    event.preventDefault();
    this.metodoUpdate(this.state)
  }
  async metodoUpdate (data) {
    let first = data.r_first_name;
    let last = data.r_last_name;
    const dataProvider = await dataProviderFactory("rest");
    const bodyRequest = {
      id: this.props.bookingId, data: {
        r_first_name: first,
        r_last_name: last
      }
    };
    dataProvider(UPDATE, "clients/updateBooking", bodyRequest)
      .then((response) => { 
        console.log(response)
        this.setState({ r_last_name: null, r_first_name: null , showDialog: false, editBooking: false });
      })
      .catch((e) => {
        console.error(e);
      });
  }

  renderRiderOrPassengerRows(data, isRider) {
    const prefix = isRider ? 'r_' : 'p_';
    return (
      <Fragment>
        <tr>
          <td>
            <b>Name:</b>{" "}{prop(`${prefix}first_name`, data)}{" "}{prop(`${prefix}last_name`, data)}
          </td>
          <td>
            { this.state.editBooking == true && (
              <div>
                <input label="First Name" placeholder="First Name" value={this.state.r_first_name} type="text" onChange={(e) =>
                  this.handleChange(e, "r_first_name")
                } id="r_first_name" name="r_first_name" />
                <input label="Last Name" placeholder="Last Name" style={{ marginLeft: '8px' }} onChange={(e) =>
                  this.handleChange(e, "r_last_name")
                } type="text" value={this.state.r_last_name} id="r_last_name" name="r_last_name" />  
              </div>
            )}
          </td>
          <td>{ this.state.editBooking == false && (
              <button onClick={this.habilitarTextboxBooking}>Edit</button>
              )}
              { this.state.editBooking == true && (
              <button onClick={(e) => this.handleSubmitEditBooking(e)}>Save</button>
              )}
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <b>Address:</b>{" "}
            {prop(`${prefix}address`, data)}{", "}
            {prop(`${prefix}zip`, data)}{", "}
            {prop(`${prefix}city`, data)}{", "}
            {prop(`${prefix}state_province`, data)}{", "}
            {`${isRider ? data.country.country : data.passenger_country.country}`}
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <b>Nationality:</b>{" "}{getNationality(this.state.countries, prop(`${prefix}nationality`, data))}
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <b>Phone Numbers:</b>{" "}
            {`${prop(`${prefix}home_phone`, data)} (home)`}{" "}
            {`${prop(`${prefix}work_phone`, data)} (work)`}
          </td>
        </tr>
        <tr>
          <td>
            <b>Email:</b>{" "}{prop(`${prefix}email`, data)}
          </td>
          <td>
            <b>Date of Birth:</b>{" "}
            {data.r_birthday
              ? moment(prop(`${prefix}birthday`, data)).format("DD-MM-YYYY")
              : "Not Available"
            }
            {" "}
            {`(${moment().diff(moment(prop(`${prefix}birthday`, data)), "years")} years)`}
          </td>
        </tr>
        <tr>
          <td>
            <b>Passport:</b>{" "}{prop(`${prefix}passport`, data)}
          </td>
          <td>
            <b>Driving Licence:</b>{" "}{prop(`${prefix}license`, data)}
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <b>Occupation:</b>{" "}{prop(`${prefix}occupation`, data)}
          </td>
        </tr>
        <tr>
          <td>
            <b>Height:</b>{" "}{prop(`${prefix}height`, data)}{" "}
            {prop(`${prefix}height_unit`, data) === "1" ? "ft" : "m"}
          </td>
          <td>
            <b>Weight:</b>{" "}{prop(`${prefix}weight`, data)}{" "}
            {prop(`${prefix}weight_unit`, data) === "1" ? "lbs" : "kg"}
          </td>
        </tr>
        <tr>
          <td>
            <b>Languages spoken:</b>{" "}
            {prop(`${prefix}english`, data) ? "English," : ""}{" "}
            {prop(`${prefix}spanish`, data) ? "Spanish," : ""}{" "}
            {prop(`${prefix}french`, data) ? "French," : ""}{" "}
            {prop(`${prefix}german`, data) ? "German," : ""}{" "}
            {prop(`${prefix}portuguese`, data) ? "Portuguese" : ""}
          </td>
          <td>
            <b>T-shirt size:</b>{" "}{prop(`${prefix}shirt`, data) && Number(prop(`${prefix}shirt`, data)) > 0 ? (prop(prop(`${prefix}shirt`, data), shirtSize) || "N/A") : "N/A"}
          </td>
        </tr>
      </Fragment>
    );
  };

  renderPreviousToursTable(data) {
    const isBeforeToday = (t) => {
      return (
        !isNil(t.booking.tour) &&
        moment(t.booking.tour.tour_end_date).isBefore(moment())
      );
    };

    const pastRentals = filter(isBeforeToday, propOr([], 'pastRentals', data));

    return (
      <table width="100%">
        <tr style={{ backgroundColor: "#ff9800", textAlign: "left" }}>
          <th>ID</th>
          <th>TOUR</th>
          <th>FIRST NAME</th>
          <th>LAST NAME</th>
          <th>VEHICLE</th>
        </tr>
        {isEmpty(pastRentals) && (
          <tr>
            <td colspan="5">
              None
            </td>
          </tr>
        )}
      
        {map(rental => {
          return (
            <tr key={rental.id}>
            <td>{rental.id}</td>
            <td>
              {rental.booking.tour.tour_name.tour_name_en}
              {" — "}
              {this.renderTourDates(rental.booking.tour)}
            </td>
            <td>{rental.booking.r_first_name}</td>
            <td>{rental.booking.r_last_name}</td>
            <td>
              { (rental.vehicle.length !== 0) ? head(rental.vehicle).model.model_name : 'Own'}
              {" - "}
              { (rental.vehicle.length !== 0) ? head(rental.vehicle).licence_plate : 'Motorcycle'} 
              { (rental.vehicle.length !== 0) ? head(rental.vehicle).renting ? "®" : "" : ''}
            </td>
          </tr>
          )
          }
        , pastRentals)}
      </table>
    );
  }

  render() {
    const { showDialog, data } = this.state;
    let gpsPrice = 0;
    let singlePrice = 0;
    let vipInsurancePrice = 0;
    let cancelInsurancePercentage = 0;
    let cancelInsuranceValue1 = 0;
    let cancelInsuranceValue2 = 0;
    let model1Price = 0;
    let model2Price = 0;
    let tourDays = 0;
    let tourTotal1 = 0;
    let tourTotal = 0;
    let tourTotal2 = 0;
    let passengerPrice = 0;

    if (!isNil(data)) {
      tourDays = moment(data.tour.effective_end_date).diff(
        moment(data.tour.effective_start_date),
        "days"
      );

      if (!isNil(data.model_1)) {
        model1Price =
          prop(
            "price",
            head(
              filter(
                propEq(
                  "price_item_sub_type",
                  `tour_${data.model_1.upgrade_type}`
                ),
                data.tour_prices
              )
            )
          ) || 0;
      }

      if (!isNil(data.model_2)) {
        model2Price =
          prop(
            "price",
            head(
              filter(
                propEq(
                  "price_item_sub_type",
                  `tour_${data.model_2.upgrade_type}`
                ),
                data.tour_prices
              )
            )
          ) || 0;
      }

      gpsPrice = data.r_gps
        ? prop(
          "price",
          head(filter(propEq("price_item_type", "gps_device"), data.gpsPrices))
        )
        : 0;

      singlePrice = data.r_single
        ? prop(
          "price",
          head(
            filter(propEq("price_item_sub_type", "tour_single"), data.tour_prices)
          )
        )
        : 0;

      passengerPrice =
        prop(
          "price",
          head(
            filter(
              propEq("price_item_sub_type", "tour_passenger"),
              data.tour_prices
            )
          )
        ) || 0;

      tourTotal =
        // data.model_1.model_name !== "Own Motorcycle"
        !isNil(data.model_1)
          ? prop(
            "price",
            head(
              filter(propEq("price_item_sub_type", "tour_total"), data.tour_prices)
            )
          )
          : passengerPrice;

      vipInsurancePrice = data.r_insurance
        ? prop(
          "price",
          head(
            filter(
              propEq("price_item_id", 1),
              filter(propEq("price_item_type", "insurance"), data.insurancePrices)
            )
          )
        )
        : 0;

      cancelInsurancePercentage = data.r_cancel_insurance
        ? prop(
          "percentage",
          head(
            filter(
              propEq("price_item_id", 3),
              filter(propEq("price_item_type", "insurance"), data.insurancePrices)
            )
          )
        )
        : 0;

      cancelInsuranceValue1 = data.r_cancel_insurance
        ? ((tourTotal +
          gpsPrice * tourDays +
          passengerPrice +
          singlePrice +
          model1Price) *
          cancelInsurancePercentage) /
        100
        : 0;

      tourTotal1 =
        cancelInsuranceValue1 +
        (tourTotal +
          gpsPrice * tourDays +
          vipInsurancePrice * tourDays +
          passengerPrice +
          singlePrice +
          model1Price);

      cancelInsuranceValue2 = data.r_cancel_insurance
        ? ((tourTotal +
          gpsPrice * tourDays +
          passengerPrice +
          singlePrice +
          model2Price) *
          cancelInsurancePercentage) /
        100
        : 0;

      tourTotal2 =
        cancelInsuranceValue2 +
        (tourTotal +
          gpsPrice * tourDays +
          vipInsurancePrice * tourDays +
          passengerPrice +
          singlePrice +
          model2Price);
    }

    const calcExperienceYears = (experienceYears) => {
      experienceYears = parseInt(experienceYears, 10);
      let experienceYearsNumber = 0;
      if (!Number.isNaN(experienceYears)) {
        experienceYearsNumber = experienceYears.toString().length === 4 ? (new Date().getFullYear()) - experienceYears : experienceYears
      }
      return experienceYearsNumber;
    }

    return (
      <Fragment>
        <Book
          titleAccess="TOUR BOOKING FORM"
          onClick={this.handleClick}
          cursor="pointer"
        />
        <Dialog
          fullWidth={true}
          maxWidth={"md"}
          open={showDialog}
          onClose={this.handleCloseClick}
          aria-label="TOUR BOOKING FORM"
        >
          {isNil(data) && <LinearProgress />}
          {!isNil(data) && (
            <React.Fragment>
              <DialogContent>
                <table border="0" cellpadding="5" spacing="5" width="100%">
                  <tr>
                    <td colspan="2">
                      <StyledH4>TOUR BOOKING FORM</StyledH4>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <b>Tour:</b>
                      {" "}
                      {data.tour.tour_name.tour_name_en}
                      {" — "}
                      {this.renderTourDates(data.tour)}
                      {" "}
                      {`${data.tour.tour_name.tour_desc ? `(${data.tour.tour_name.tour_desc})` : ''}`}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <StyledH4>Motorcycle</StyledH4>
                      <b>{`${!isNil(data.model_1) ? data.model_1.model_name : "Own Motorcycle"} (first choice)`}</b>
                      {", "}
                      {`${data.model_2.model_name} (second choice)`}
                    </td>
                    <td>
                      <StyledH4>Gps</StyledH4>
                      {data.r_gps ? `${gpsPrice} € / day` : "No"}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <StyledH4>Room</StyledH4>
                      {data.r_single ? "Single" : "Double"}
                    </td>
                    <td>
                      <StyledH4>Trip Cancellation Insurance</StyledH4>
                      {!data.r_cancel_insurance ? "No" : `${cancelInsurancePercentage} % of tour price`}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <StyledH4>Vip Insurance</StyledH4>
                      {!data.r_insurance ? "No" : `${vipInsurancePrice} Euros/day`}
                    </td>
                    <td>
                      <StyledH4>IMT Rewards</StyledH4>
                      {!data.reward_used ? "No" : `${data.rewards} Cash Discount`}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <StyledH4>Total Tour Cost</StyledH4>
                      {`First choice of motorcycle: ${Math.round(tourTotal1, 0)} Euros`}
                      <br />
                      {`Second choice of motorcycle: ${Math.round(tourTotal2, 0)} Euros`}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <StyledH4>Rider Info</StyledH4>
                    </td>
                  </tr>
                  {this.renderRiderOrPassengerRows(data, true)}
                  {!isNil(data.p_first_name) && !isEmpty(data.p_first_name) && (
                    <Fragment>
                      <tr>
                        <td>
                          <StyledH4>Passenger Info</StyledH4>
                        </td>
                      </tr>
                      {this.renderRiderOrPassengerRows(data, false)}
                    </Fragment>
                  )}
                  <tr>
                    <td>
                      <StyledH4>Emergency Information</StyledH4>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <b>Emergency contact Name:</b>{" "}{data.r_emergency_name}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <b>Relationship:</b>{" "}{data.r_emergency_relationship}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <b>Emergency tel:</b>{" "}{data.r_emergency_phone}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <StyledH4>Rider Experience</StyledH4>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>Years Riding:</b>{" "}{`${calcExperienceYears(data.r_experience_years)} years`}
                    </td>
                    <td>
                      <b>Riding Experience:</b>{" "}
                      {data.r_street ? "Street," : ""}{" "}
                      {data.r_sweepers ? "Sweepers," : ""}{" "}
                      {data.r_twisties ? "Twisties," : ""}{" "}
                      {data.r_track ? "Track," : ""}{" "}
                      {data.r_off_road ? "Off-road" : ""}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>Riding last year:</b>{" "}
                      {data.r_experience_past_year}{" "}
                      {data.r_experience_past_year_unit === "1" ? "km" : "miles"}
                    </td>
                    <td>
                      <b>Average ride distance:</b>{" "}
                      {data.r_experience_ride_distance}{" "}
                      {data.r_experience_ride_distance_unit === "1" ? "km" : "miles"}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <b>Motorcycle(s) owned:</b>{" "}{data.r_own_models}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <b>Previous Tours:</b>{" "}{data.r_tour_group}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <b>Previous IMTBIKE Tours:</b>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      {this.renderPreviousToursTable(data)}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ whiteSpace: "pre-line" }}>
                      <StyledH4>Comments</StyledH4>
                      {`${!isNil(data.r_comments) && !isEmpty(data.r_comments) ? data.r_comments : 'None'}`}
                    </td>
                    <td style={{ whiteSpace: "pre-line", verticalAlign: "top" }}>
                      <StyledH4>Allergy/Special Diet</StyledH4>
                      {`${!isNil(data.r_allergy_special_diet) && !isEmpty(data.r_allergy_special_diet) ? data.r_allergy_special_diet : 'None'}`}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: "top" }} colspan="2">
                      <StyledH4>How did you find out about us?</StyledH4>
                      {pathOr('Not Available', ['referral', 'name'], data)}
                    </td>
                  </tr>
                </table>
              </DialogContent>
            </React.Fragment>
          )}
          <DialogActions>
            <Button label="Close" onClick={this.handleCloseClick}>
              <IconCancel />
            </Button>
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TourBookingFormButton);



// WEBPACK FOOTER //
// ./src/components/tourBookingForm.js